// extracted by mini-css-extract-plugin
export default {"uni-box-main-slot":"uni-box-main-slot__zZkmq"};